import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './ButtonLink.scss';
var Sizes = {
    SMALL: 'small',
    MEDIUM: 'medium'
};
var ButtonLink = function (_a) {
    var className = _a.className, isDarkMode = _a.isDarkMode, isDisabled = _a.isDisabled, label = _a.label, onClick = _a.onClick, size = _a.size, type = _a.type, props = __rest(_a, ["className", "isDarkMode", "isDisabled", "label", "onClick", "size", "type"]);
    var buttonLinkClassName = classnames('ButtonLink', "ButtonLink--".concat(size), className, {
        'ButtonLink--isDarkMode': isDarkMode,
        'ButtonLink--isDisabled': isDisabled
    });
    /* eslint-disable react/button-has-type */
    // Disabling rule because `type` prop must be more strictly
    // enforced and the work to do so is beyond the scope of
    // THRIVE-8639
    return (React.createElement("button", __assign({}, props, { className: buttonLinkClassName, disabled: isDisabled, onClick: onClick, type: type }), label));
    /* eslint-enable react/button-has-type */
};
ButtonLink.defaultProps = {
    isDarkMode: false,
    isDisabled: false,
    size: Sizes.MEDIUM,
    type: 'button'
};
ButtonLink.propTypes = {
    /** An optional class name to render on the root node */
    className: PropTypes.string,
    /** Whether the button is rendering on a dark background */
    isDarkMode: PropTypes.bool,
    /** Whether the button should render in a disabled state */
    isDisabled: PropTypes.bool,
    /** The button text */
    label: PropTypes.node.isRequired,
    /** Function to call when clicked */
    onClick: PropTypes.func.isRequired,
    /** Size of the button text */
    size: PropTypes.oneOf(Object.values(Sizes)),
    /** The native HTML button type to render */
    type: PropTypes.oneOf(['button', 'submit'])
};
export default ButtonLink;
//# sourceMappingURL=ButtonLink.js.map